import { createTransform } from 'redux-persist';

import { ReduxState } from 'src/store/types';

type PrunedVoiceboxState = Pick<ReduxState['voicebox'], 'openAiKey'>;

export const pruneVoicebox = createTransform<
  ReduxState['voicebox'],
  PrunedVoiceboxState,
  ReduxState
>(
  (voiceboxState) => {
    const persistableState: PrunedVoiceboxState = {
      openAiKey: voiceboxState.openAiKey || '',
    };

    return persistableState;
  },
  null,
  { whitelist: ['voicebox'] }
);
